export default __webpack_public_path__ + "static/media/rightJoystickArrow.4d8953c6.svg";